import customToast from "component/Toastr";
import moment from "moment";
import React from "react";
import Moment from "react-moment";
import { AppointmentAvailableTime, AppointmentAvailableTimeLoader } from "store/slices/appointmentSlice";
import { StaffAvailableEndBusyTimeApi, StaffAvailableStartBusyTimeApi, StaffAvailableTimeApi } from "store/slices/staffSlice";
import {
  availabilityRequestLane,
  calendarAvailabilityRequests,
} from "pages/calendar/Form/availabilityRequestCoordinator";
import { normalizeCalendarFormIdentity } from "pages/calendar/Form/calendarFormIdentity";
import { readableApiError } from "helpers/apiError";
import { buildAppointmentResourceAvailabilityRequest } from "pages/calendar/Form/appointmentFormUtils";

const selectedResourceConflict = (values, availability) => {
  if (values.id || !values.duration || !values.dateof || !values.start_time) return false;
  const formats = ["YYYY-MM-DD HH:mm:ss", "YYYY-MM-DDTHH:mm:ss"];
  const selected = moment(buildAppointmentResourceAvailabilityRequest(values).start_datetime, formats, true);
  if (!selected.isValid()) return false;
  if (availability.requested_start_datetime) {
    const requested = moment(availability.requested_start_datetime, formats, true);
    if (!requested.isValid() || !requested.isSame(selected)) return false;
  }
  // The server checks the selected salon wall time. Never replace that time
  // with the browser's current clock when booking an earlier slot today.
  if (typeof availability.resource_conflict === "boolean") return availability.resource_conflict;
  const available = moment(availability.start_datetime, formats, true);
  return !available.isValid() || !available.isSame(selected);
};

const GetAvailableTime = (values, dispatch) => {
  const formtype = values && values.formtype ? values.formtype : "";
  const formIdentity = normalizeCalendarFormIdentity(values);
  if (formIdentity.kind === "busy-time") {
    if (values.staff_id && values.dateof) {
      if (values.availableBusyTime === "start") {
        calendarAvailabilityRequests.run(
          availabilityRequestLane(values),
          () => dispatch(StaffAvailableStartBusyTimeApi({ ...values, roster_time: true, formtype })),
        ).then((action) => {
          if (action.meta.requestStatus === "fulfilled") {
            const payloaddata = action.payload;
            if (payloaddata.time && payloaddata.time.length == 0) {
              if (payloaddata.appointment && payloaddata.appointment.length > 0) {
                customToast.success(`There is not enough time available for this service.`);
              } else if (payloaddata.addonservices && payloaddata.addonservices.length > 0) {
                customToast.success(`Add-on services not available at this time`);
              } else if (payloaddata.breaktime && payloaddata.breaktime.length > 0) {
                customToast.success(`Please choose another time as business is breaktime`);
              } else if (payloaddata.busytime && payloaddata.busytime.length > 0) {
                customToast.success(`This staff member is busy at this time`);
              } else if (payloaddata.booking && payloaddata.booking.length > 0) {
                customToast.success(`This staff member is on break at this time`);
              } else {
                customToast.success(`There is not enough time available for this service.`);
              }
            }
          } else if (action.meta.requestStatus === "rejected") {
            const status = action.payload && action.payload.status;
            const errors = action.payload && action.payload.message && action.payload.message.errors;
            const response = action.payload && action.payload.message && action.payload.message;
            if (status === 422) {
              const NotifyContent = () => {
                return (
                  <>
                    <p className="mb-2 text-light text-justify">{response && response.message}</p>
                    <ul className="list-unstyled">
                      {errors &&
                        Object.keys(errors).map((a, n) => {
                          if (errors[a].length > 0) {
                            return (
                              <>
                                {errors[a].map((as, ns) => {
                                  return (
                                    <li key={n + "-" + ns} className="text-light form-text text-start">
                                      {as}
                                    </li>
                                  );
                                })}
                              </>
                            );
                          }
                        })}
                    </ul>
                  </>
                );
              };
              customToast.error(<NotifyContent />);
            } else if (status === 410) {
              const NotifyContent = () => {
                return (
                  <>
                    <p className="mb-2 text-white text-justify">{response && response.message}</p>
                    {response && response.booked && response.booked.length > 0 && (
                      <>
                        <p className="mb-2 text-white text-justify">Staff are available at this time.</p>
                        {response && response.dateof && <Moment format="MMMM DD YYYY">{response.dateof}</Moment>}
                        <ul className="list-unstyled">
                          {response.booked.map((a, n) => (
                            <li key={n} className="text-light form-text">
                              <Moment format="hh:mm A">{response.dateof + "T" + a}</Moment>
                            </li>
                          ))}
                        </ul>
                      </>
                    )}
                  </>
                );
              };
              customToast.error(<NotifyContent />);
            }
          }
        });
      }
      if (values.availableBusyTime === "end") {
        calendarAvailabilityRequests.run(
          availabilityRequestLane(values),
          () => dispatch(StaffAvailableEndBusyTimeApi({ ...values, roster_time: true, formtype })),
        ).then((action) => {
          if (action.meta.requestStatus === "fulfilled") {
            const payloaddata = action.payload;
            if (payloaddata.time && payloaddata.time.length == 0) {
              if (payloaddata.appointment && payloaddata.appointment.length > 0) {
                customToast.success(`There is not enough time available for this service.`);
              } else if (payloaddata.addonservices && payloaddata.addonservices.length > 0) {
                customToast.success(`Add-on services not available at this time`);
              } else if (payloaddata.breaktime && payloaddata.breaktime.length > 0) {
                customToast.success(`Please choose another time as business is breaktime`);
              } else if (payloaddata.busytime && payloaddata.busytime.length > 0) {
                customToast.success(`This staff member is busy at this time`);
              } else if (payloaddata.booking && payloaddata.booking.length > 0) {
                customToast.success(`This staff member is on break at this time`);
              } else {
                customToast.success(`There is not enough time available for this service.`);
              }
            }
          } else if (action.meta.requestStatus === "rejected") {
            const status = action.payload && action.payload.status;
            const errors = action.payload && action.payload.message && action.payload.message.errors;
            const response = action.payload && action.payload.message && action.payload.message;
            if (status === 422) {
              const NotifyContent = () => {
                return (
                  <>
                    <p className="mb-2 text-light text-justify">{response && response.message}</p>
                    <ul className="list-unstyled">
                      {errors &&
                        Object.keys(errors).map((a, n) => {
                          if (errors[a].length > 0) {
                            return (
                              <>
                                {errors[a].map((as, ns) => {
                                  return (
                                    <li key={n + "-" + ns} className="text-light form-text text-start">
                                      {as}
                                    </li>
                                  );
                                })}
                              </>
                            );
                          }
                        })}
                    </ul>
                  </>
                );
              };
              customToast.error(<NotifyContent />);
            } else if (status === 410) {
              const NotifyContent = () => {
                return (
                  <>
                    <p className="mb-2 text-white text-justify">{response && response.message}</p>
                    {response && response.booked && response.booked.length > 0 && (
                      <>
                        <p className="mb-2 text-white text-justify">Staff are available at this time.</p>
                        {response && response.dateof && <Moment format="MMMM DD YYYY">{response.dateof}</Moment>}
                        <ul className="list-unstyled">
                          {response.booked.map((a, n) => (
                            <li key={n} className="text-light form-text">
                              <Moment format="hh:mm A">{response.dateof + "T" + a}</Moment>
                            </li>
                          ))}
                        </ul>
                      </>
                    )}
                  </>
                );
              };
              customToast.error(<NotifyContent />);
            }
          }
        });
      }
    } else {
      dispatch({ type: "staff/StaffAvailableTime/rejected" });
    }
  } else {
    if (values && values.service_id && values.staff_id && values.dateof) {
      if (formtype === "appointmentautofillForm") {
        dispatch(AppointmentAvailableTimeLoader(true));
      }
      calendarAvailabilityRequests.run(
        availabilityRequestLane(values),
        () => dispatch(StaffAvailableTimeApi({
          ...values,
          roster_time: true,
          formtype,
          // Every main appointment field refresh feeds the Start Time picker.
          // Preserve all available alternatives even outside the settled form effect.
          list_all_slots: values.list_all_slots === true ||
            (formIdentity.kind === "appointment" && ["add", "edit"].includes(formIdentity.mode)),
        })),
      ).then((action) => {
        // console.log("action",JSON.stringify(action,null,2));
        // console.log("values", values)
        if (action.meta.requestStatus === "fulfilled") {
          if (formtype != "appointmentautofillForm") {
            const availability = action.payload || {};
            if (availability.service_assign_resource) {
              if (selectedResourceConflict(values, availability)) {
                customToast.error("Any Resource is not available this time");
              }
            } else if (!availability.start_datetime) {
              customToast.error("Staff is not available this time");
            }
          }

          const payloaddata = action.payload;
          dispatch(AppointmentAvailableTimeLoader(false));
          if (formtype === "appointmentautofillForm") {
            dispatch(AppointmentAvailableTime(payloaddata))
          }
          if (payloaddata.time && payloaddata.time.length == 0) {
            if (payloaddata.appointment && payloaddata.appointment.length > 0) {
              customToast.success(`There is not enough time available for this service.`);
            } else if (payloaddata.addonservices && payloaddata.addonservices.length > 0) {
              customToast.success(`Add-on services not available at this time`);
            } else if (payloaddata.breaktime && payloaddata.breaktime.length > 0) {
              customToast.success(`Please choose another time as business is breaktime`);
            } else if (payloaddata.busytime && payloaddata.busytime.length > 0) {
              customToast.success(`This staff member is busy at this time`);
            } else if (payloaddata.booking && payloaddata.booking.length > 0) {
              customToast.success(`This staff member is on break at this time`);
            } else {
              customToast.success(`There is not enough time available for this service.`);
            }
          }
        } else if (action.meta.requestStatus === "rejected") {
          const status = action.payload && action.payload.status;
          const response = action.payload && action.payload.message && action.payload.message;
          if (status === 422) {
            customToast.error(readableApiError(action.payload?.message || action.payload, "Unable to check appointment availability."));
          } else if (status === 410) {
            const NotifyContent = () => {
              return (
                <>
                  <p className="mb-2 text-white text-justify">{readableApiError(action.payload?.message || action.payload, "Unable to check appointment availability.")}</p>
                  {response && response.booked && response.booked.length > 0 && (
                    <>
                  <p className="mb-2 text-white text-justify">Staff are available at this time.</p>
                      {response && response.dateof && <Moment format="MMMM DD YYYY">{response.dateof}</Moment>}
                      <ul className="list-unstyled">
                        {response.booked.map((a, n) => (
                          <li key={n} className="text-light form-text">
                            <Moment format="hh:mm A">{response.dateof + "T" + a}</Moment>
                          </li>
                        ))}
                      </ul>
                    </>
                  )}
                </>
              );
            };
            customToast.error(<NotifyContent />);
          }
        }
      });
    } 
    // else if (values && values.listview === "BusyTime" && values.staff_id && values.dateof) {
    //   if (values.availableBusyTime === "start") {
    //     dispatch(StaffAvailableStartBusyTimeApi({ ...values, roster_time: true, formtype })).then((action) => {
    //       if (action.meta.requestStatus === "fulfilled") {
    //         const payloaddata = action.payload;
    //         if (payloaddata.time && payloaddata.time.length == 0) {
    //           if (payloaddata.appointment && payloaddata.appointment.length > 0) {
    //             customToast.success(`There is not enough time available for this service.`);
    //           } else if (payloaddata.addonservices && payloaddata.addonservices.length > 0) {
    //             customToast.success(`Add-on services not available at this time`);
    //           } else if (payloaddata.breaktime && payloaddata.breaktime.length > 0) {
    //             customToast.success(`Please choose another time as business is breaktime`);
    //           } else if (payloaddata.busytime && payloaddata.busytime.length > 0) {
    //             customToast.success(`This staff member is busy at this time`);
    //           } else if (payloaddata.booking && payloaddata.booking.length > 0) {
    //             customToast.success(`This staff member is on break at this time`);
    //           } else {
    //             customToast.success(`There is not enough time available for this service.`);
    //           }
    //         }
    //       } else if (action.meta.requestStatus === "rejected") {
    //         const status = action.payload && action.payload.status;
    //         const errors = action.payload && action.payload.message && action.payload.message.errors;
    //         const response = action.payload && action.payload.message && action.payload.message;
    //         if (status === 422) {
    //           const NotifyContent = () => {
    //             return (
    //               <>
    //                 <p className="mb-2 text-light text-justify">{response && response.message}</p>
    //                 <ul className="list-unstyled">
    //                   {errors &&
    //                     Object.keys(errors).map((a, n) => {
    //                       if (errors[a].length > 0) {
    //                         return (
    //                           <>
    //                             {errors[a].map((as, ns) => {
    //                               return (
    //                                 <li key={n + "-" + ns} className="text-light form-text text-start">
    //                                   {as}
    //                                 </li>
    //                               );
    //                             })}
    //                           </>
    //                         );
    //                       }
    //                     })}
    //                 </ul>
    //               </>
    //             );
    //           };
    //           customToast.error(<NotifyContent />);
    //         } else if (status === 410) {
    //           const NotifyContent = () => {
    //             return (
    //               <>
    //                 <p className="mb-2 text-white text-justify">{response && response.message}</p>
    //                 {response && response.booked && (
    //                   <>
    //                     <p className="mb-2 text-white text-justify">{t("Staff are available at this time.")}</p>
    //                     {response && response.dateof && <Moment format="MMMM DD YYYY">{response.dateof}</Moment>}
    //                     <ul className="list-unstyled">
    //                       {response.booked.map((a, n) => (
    //                         <li key={n} className="text-light form-text">
    //                           <Moment format="hh:mm A">{response.dateof + "T" + a}</Moment>
    //                         </li>
    //                       ))}
    //                     </ul>
    //                   </>
    //                 )}
    //               </>
    //             );
    //           };
    //           customToast.error(<NotifyContent />);
    //         }
    //       }
    //     });
    //   }
    //   if (values.availableBusyTime === "end") {
    //     dispatch(StaffAvailableEndBusyTimeApi({ ...values, roster_time: true, formtype })).then((action) => {
    //       if (action.meta.requestStatus === "fulfilled") {
    //         const payloaddata = action.payload;
    //         if (payloaddata.time && payloaddata.time.length == 0) {
    //           if (payloaddata.appointment && payloaddata.appointment.length > 0) {
    //             customToast.success(`There is not enough time available for this service.`);
    //           } else if (payloaddata.addonservices && payloaddata.addonservices.length > 0) {
    //             customToast.success(`Add-on services not available at this time`);
    //           } else if (payloaddata.breaktime && payloaddata.breaktime.length > 0) {
    //             customToast.success(`Please choose another time as business is breaktime`);
    //           } else if (payloaddata.busytime && payloaddata.busytime.length > 0) {
    //             customToast.success(`This staff member is busy at this time`);
    //           } else if (payloaddata.booking && payloaddata.booking.length > 0) {
    //             customToast.success(`This staff member is on break at this time`);
    //           } else {
    //             customToast.success(`There is not enough time available for this service.`);
    //           }
    //         }
    //       } else if (action.meta.requestStatus === "rejected") {
    //         const status = action.payload && action.payload.status;
    //         const errors = action.payload && action.payload.message && action.payload.message.errors;
    //         const response = action.payload && action.payload.message && action.payload.message;
    //         if (status === 422) {
    //           const NotifyContent = () => {
    //             return (
    //               <>
    //                 <p className="mb-2 text-light text-justify">{response && response.message}</p>
    //                 <ul className="list-unstyled">
    //                   {errors &&
    //                     Object.keys(errors).map((a, n) => {
    //                       if (errors[a].length > 0) {
    //                         return (
    //                           <>
    //                             {errors[a].map((as, ns) => {
    //                               return (
    //                                 <li key={n + "-" + ns} className="text-light form-text text-start">
    //                                   {as}
    //                                 </li>
    //                               );
    //                             })}
    //                           </>
    //                         );
    //                       }
    //                     })}
    //                 </ul>
    //               </>
    //             );
    //           };
    //           customToast.error(<NotifyContent />);
    //         } else if (status === 410) {
    //           const NotifyContent = () => {
    //             return (
    //               <>
    //                 <p className="mb-2 text-white text-justify">{response && response.message}</p>
    //                 {response && response.booked && (
    //                   <>
    //                     <p className="mb-2 text-white text-justify">{t("Staff are available at this time.")}</p>
    //                     {response && response.dateof && <Moment format="MMMM DD YYYY">{response.dateof}</Moment>}
    //                     <ul className="list-unstyled">
    //                       {response.booked.map((a, n) => (
    //                         <li key={n} className="text-light form-text">
    //                           <Moment format="hh:mm A">{response.dateof + "T" + a}</Moment>
    //                         </li>
    //                       ))}
    //                     </ul>
    //                   </>
    //                 )}
    //               </>
    //             );
    //           };
    //           customToast.error(<NotifyContent />);
    //         }
    //       }
    //     });
    //   }

    // } 
    else {
      dispatch({ type: "staff/StaffAvailableTime/rejected" });
    }
  }
};

const GetTotalDurationWithPadding = (durationWithPadding, addonservices = [], addanotherservices = [], addOnWithinOriginalTime = false) => {
  const totalAddOnDurationWithPadding = addonservices && addonservices.length > 0 && addonservices.reduce((sum, sduration) => {
    // Check if sduration.durationWithPadding is a valid duration
    const duration = moment.duration(sduration.durationWithPadding);
    if (duration.isValid()) {
      const sumDurationWithPadding = moment.duration(sduration.durationWithPadding);
      return sum.add(sumDurationWithPadding);
    }
    return sum;
  }, moment.duration(0));


  const totalAddAnotherDurationWithPadding = addanotherservices.length > 0 && addanotherservices.reduce((sum, sduration) => {
    // Check if sduration.durationWithPadding is a valid duration
    const duration = moment.duration(sduration.durationWithPadding);
    if (duration.isValid()) {
      const sumDurationWithPadding = moment.duration(sduration.durationWithPadding);
      return sum.add(sumDurationWithPadding);
    }
    return sum;
  }, moment.duration(0));

  const duration1 = moment.duration(durationWithPadding);
  const duration2 = totalAddOnDurationWithPadding;
  const duration3 = totalAddAnotherDurationWithPadding;

  // Check if each duration is valid before using it
  const minutes1 = duration1 && duration1.isValid() ? duration1.asMinutes() : 0;
  const minutes2 = ![true, 1, "1"].includes(addOnWithinOriginalTime) && duration2 && duration2.isValid() ? duration2.asMinutes() : 0;
  const minutes3 = duration3 && duration3.isValid() ? duration3.asMinutes() : 0;

  const totalMinutes = minutes1 + minutes2 + minutes3;
  if (totalMinutes > 0) {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    const sumDuration = moment({ hours, minutes });
    const SumOfDuration = sumDuration ? sumDuration.format('HH:mm') : "";
    // console.log(SumOfDuration);
    const durationMoment = moment.duration(SumOfDuration);

    return { totalHours: SumOfDuration, totalMinutes: totalMinutes, durationMoment }
  } else {
    return { totalHours: "", totalMinutes: "", durationMoment: "" }
  }
};
export { GetAvailableTime, GetTotalDurationWithPadding };
